var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgKebab = function SvgKebab(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 17,
    viewBox: "0 0 4 17",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99406 13.5C1.44406 13.5 0.994059 13.95 1.00006 14.5C1.00006 15.05 1.45006 15.5 2.00006 15.5C2.55006 15.5 3.00006 15.05 3.00006 14.5C3.00006 13.95 2.55006 13.5 1.99406 13.5Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99406 7.5C1.44406 7.5 0.994059 7.95 1.00006 8.5C1.00006 9.05 1.45006 9.5 2.00006 9.5C2.55006 9.5 3.00006 9.05 3.00006 8.5C3.00006 7.95 2.55006 7.5 1.99406 7.5Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99406 1.5C1.44406 1.5 0.994059 1.95 1.00006 2.5C1.00006 3.05 1.45006 3.5 2.00006 3.5C2.55006 3.5 3.00006 3.05 3.00006 2.5C3.00006 1.95 2.55006 1.5 1.99406 1.5Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKebab);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "01996aa7de4e3c7b14c1ecc83f1c45d8.svg";